"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVideoMarkerTitleProperty = exports.videoMarkerTitlePropertyDefinition = void 0;
exports.videoMarkerTitlePropertyDefinition = {
    name: 'video-marker-title',
    type: 'text',
    multiple: false,
    view: {
        label: 'Title',
        style: '',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'maxLength',
            argument: 50,
        },
    ],
};
const isVideoMarkerTitleProperty = (prop) => {
    return prop.name === exports.videoMarkerTitlePropertyDefinition.name;
};
exports.isVideoMarkerTitleProperty = isVideoMarkerTitleProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlkZW8tbWFya2VyLXRpdGxlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdmlkZW8tbWFya2VyLXRpdGxlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsa0NBQWtDLEdBQUc7SUFDaEQsSUFBSSxFQUFFLG9CQUFvQjtJQUMxQixJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLE9BQU87UUFDZCxLQUFLLEVBQUUsRUFBRTtLQUNWO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsV0FBVztZQUNqQixRQUFRLEVBQUUsRUFBRTtTQUNiO0tBQ0Y7Q0FDOEIsQ0FBQTtBQUkxQixNQUFNLDBCQUEwQixHQUFHLENBQUMsSUFBa0IsRUFBb0MsRUFBRTtJQUNqRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssMENBQWtDLENBQUMsSUFBSSxDQUFBO0FBQzlELENBQUMsQ0FBQTtBQUZZLFFBQUEsMEJBQTBCLDhCQUV0QyJ9